export default {
  SUBSCRIPTIONS_FETCHED: 'PARTNER_CUPONS_FETCHED',
  SUBSCRIPTIONS_LOAD: 'PARTNER_CUPONS_LOAD',
};
